import { API_ENDPOINT } from './config';

export const urlsSearch = {
  search: `${API_ENDPOINT}/search`,
  searchActiveTypes: `${API_ENDPOINT}/search/active-types`,
  searchHistory: `${API_ENDPOINT}/search-history`,
  searchHistoryCsv: `${API_ENDPOINT}/search-history/download-csv`,
  searchAdminAllTypes: `${API_ENDPOINT}/search/admin/active-types/all-types`,
  searchAdminActivateDeactivateType: `${API_ENDPOINT}/search/admin/active-types/activate-deactivate`,
  searchAdminRunDatabaseImport: `${API_ENDPOINT}/search/admin/run-database-import`,
  searchAdminRunFileImport: `${API_ENDPOINT}/search/admin/run-file-import`,
};

export const routesSearch = {
  // Public
  search: '/search',
  // CMS
  cmsSearchHistory: '/cms/search-history',
  cmsSearchAdmin: '/cms/search-admin',
};
